import React from 'react'
import cn from 'classnames'

import Button from '@material-ui/core/Button'
import styles from './VNPinButton.module.scss'

/**
 * Pin input button used for number pad input
 *
 * @param {*} param
 * @returns {React.Component}
 */
const VNPinButton = ({ children, className, value, onClick, renderChildern = false }) => {
  const classNames = cn(styles.button, className)

  return (
    <Button className={classNames} onClick={() => onClick(value)}>
      {renderChildern ? children : value}
    </Button>
  )
}

export default VNPinButton
